<template>
  <v-container fluid class="hyp-table-container">
    <v-row>
      <v-col cols="12" class="details-heading application-heading pull-left">
        <span>Setup Profile </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        :style="{ 'max-height': listingHeight + 'px' }"
        class="overflow-y-auto"
      >
        <v-row>
          <v-col cols="12" class="details-heading">{{ labelType }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="pb-0">
            <span v-html="assetTypesDescription"></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-list>
              <template v-for="(systemAssetType, i) in systemAssetTypes">
                <v-divider
                  v-if="!systemAssetType"
                  :key="`divider-${i}`"
                ></v-divider>
                <v-list-item
                  v-else
                  :key="`systemAssetType-${i}`"
                  :value="systemAssetType"
                  active-class="deep-green--text text--accent-4"
                >
                  <template v-slot:default="{}">
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="systemAssetType.title"
                      ></v-list-item-title>
                      <div v-if="editedAssetId === systemAssetType.id">
                        <v-row dense class="pt-0">
                          <v-col cols="6" class="pt-0">
                            <v-select
                              v-model="systemAssetType.color"
                              :items="colors"
                              item-text="color"
                              item-value="hex"
                              label="Select A Color"
                              single-line
                              clearable
                            >
                              <template v-slot:selection="{ item }">
                                <div
                                  class="color-holder mr-4"
                                  :style="{ 'background-color': item.hex }"
                                ></div>
                                {{ item.color }}
                              </template>
                              <template v-slot:item="{ item }">
                                <div
                                  class="color-holder mr-4"
                                  :style="{ 'background-color': item.hex }"
                                ></div>
                                {{ item.color }}
                              </template>
                            </v-select>
                          </v-col>
                          <v-col cols="6" class="pt-0">
                            <v-select
                              v-model="systemAssetType.icon"
                              :items="icons"
                              item-text="text"
                              item-value="value"
                              label="Select An Icon"
                              single-line
                              clearable
                            >
                              <template v-slot:selection="{ item }"
                                ><img
                                  :src="getDisplayIcon(item)"
                                  alt
                                  class="icon mr-4"
                                />
                                {{ item.text }}
                              </template>
                              <template v-slot:item="{ item }">
                                <img
                                  :src="getDisplayIcon(item)"
                                  alt
                                  class="icon mr-2"
                                />
                                {{ item.text }}
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                      </div>
                    </v-list-item-content>

                    <v-icon
                      small
                      class="pull-left"
                      v-show="editedAssetId !== systemAssetType.id"
                      v-on:click.prevent="
                        toggleEditSystemAsset(systemAssetType)
                      "
                      >mdi-pencil</v-icon
                    >
                    <v-list-item-action>
                      <v-switch
                        v-model="systemAssetType.enabled"
                        class="event-input-toggle pa-0 ma-0 mt-1"
                        solo
                        v-show="editedAssetId !== systemAssetType.id"
                        v-on:change="saveAssetType(systemAssetType)"
                      ></v-switch>
                      <div
                        class="pull-right mt-0 mb-0"
                        v-show="editedAssetId === systemAssetType.id"
                      >
                        <v-btn
                          small
                          class="btn primary"
                          @click.prevent="saveAssetType(systemAssetType)"
                        >
                          Save
                        </v-btn>
                        <v-btn
                          small
                          class="btn ml-2"
                          @click.prevent="toggleClose"
                        >
                          Cancel
                        </v-btn>
                      </div>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="details-heading pb-0">
            <span v-html="assetTypesCustomDescription"></span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-list>
              <template v-for="(customAssetType, i) in customAssetTypes">
                <v-divider
                  v-if="!customAssetType"
                  :key="`divider-${i}`"
                ></v-divider>
                <v-list-item
                  v-else
                  :key="`customAssetType-${i}`"
                  :value="customAssetType"
                  active-class="deep-green--text text--accent-4"
                >
                  <template v-slot:default="{}">
                    <v-list-item-content>
                      <div v-if="editedCustomAssetId === customAssetType.id">
                        <v-row dense class="pb-0">
                          <v-col cols="12" class="pb-0">
                            <v-text-field
                              v-model="customAssetType.title"
                              size="50"
                              :ref="`asset${customAssetType.id}`"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense class="pt-0">
                          <v-col cols="6" class="pt-0">
                            <v-select
                              v-model="customAssetType.color"
                              :items="colors"
                              item-text="color"
                              item-value="hex"
                              label="Select A Color"
                              single-line
                              clearable
                              class="pt-0"
                            ></v-select>
                          </v-col>
                          <v-col cols="6" class="pt-0">
                            <v-select
                              v-model="customAssetType.icon"
                              :items="icons"
                              item-text="text"
                              item-value="value"
                              label="Select An Icon"
                              single-line
                              clearable
                              class="pt-0"
                            >
                              <template v-slot:selection="{ item }"
                                ><img
                                  :src="getDisplayIcon(item)"
                                  alt
                                  class="icon mr-4"
                                />
                                {{ item.text }}
                              </template>
                              <template v-slot:item="{ item }">
                                <img
                                  :src="getDisplayIcon(item)"
                                  alt
                                  class="icon mr-2"
                                />
                                {{ item.text }}
                              </template>
                            </v-select>
                          </v-col>
                        </v-row>
                      </div>
                      <v-list-item-title
                        v-if="editedCustomAssetId !== customAssetType.id"
                        v-text="customAssetType.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                    <v-icon
                      small
                      v-show="editedCustomAssetId !== customAssetType.id"
                      v-on:click.prevent="
                        toggleEditCustomAsset(customAssetType)
                      "
                      >mdi-pencil</v-icon
                    >

                    <v-list-item-action>
                      <v-switch
                        v-model="customAssetType.enabled"
                        class="event-input-toggle pa-0 ma-0 mt-1"
                        solo
                        v-show="editedCustomAssetId !== customAssetType.id"
                        v-on:change="saveAssetType(customAssetType)"
                        :disabled="customAssetType.isDraft"
                      ></v-switch>
                      <div
                        class="pull-right"
                        v-show="editedCustomAssetId === customAssetType.id"
                      >
                        <v-btn
                          small
                          class="btn primary mt-4"
                          @click.prevent="saveAssetType(customAssetType)"
                        >
                          Save
                        </v-btn>
                        <v-btn
                          small
                          class="btn ml-2 mt-4"
                          @click.prevent="toggleClose"
                        >
                          Cancel
                        </v-btn>
                      </div>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list>
          </v-col>
        </v-row>
      </v-col>
      <v-col>
        <v-row>
          <v-col cols="12" class="details-heading ml-4 pb-0"
            >Custom Fields</v-col
          >
        </v-row>
        <v-row>
          <v-col class="pt-0 pb-0">
            <v-list>
              <template v-for="(item, i) in customAssetFields">
                <v-list-item
                  :key="`item-${i}`"
                  :value="item"
                  active-class="deep-green--text text--accent-4"
                >
                  <template v-slot:default="{}">
                    <v-list-item-content>
                      <div v-if="editedFieldId === item.id">
                        <v-text-field
                          v-model="item.title"
                          size="50"
                          :ref="`field${item.id}`"
                          :rules="specialCharactersRule"
                        />
                      </div>
                      <v-list-item-title
                        v-text="item.title"
                        v-if="editedFieldId !== item.id"
                      ></v-list-item-title>
                    </v-list-item-content>

                    <v-icon
                      small
                      v-show="editedFieldId !== item.id"
                      v-on:click.prevent="toggleEditCustomField(item)"
                      >mdi-pencil</v-icon
                    >
                    <v-list-item-action>
                      <v-switch
                        v-model="item.enabled"
                        class="event-input-toggle pa-0 ma-0 mt-1"
                        solo
                        v-show="editedFieldId !== item.id"
                        v-on:change="saveCustomField(item)"
                        :disabled="item.isDraft"
                      ></v-switch>
                      <div
                        class="pull-right"
                        v-show="editedFieldId === item.id"
                      >
                        <v-btn
                          small
                          class="btn primary mt-4"
                          @click.prevent="saveCustomField(item)"
                        >
                          Save
                        </v-btn>
                        <v-btn
                          small
                          class="btn ml-2 mt-4"
                          @click.prevent="toggleClose"
                        >
                          Cancel
                        </v-btn>
                      </div>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import uuidV4 from "uuid/v4";
import lodashSortBy from "lodash/sortBy";
import lodashIsEmpty from "lodash/isEmpty";
import { mapGetters } from "vuex";
import { LABELS } from "@/common/constants/labels";
import { MODULE_PREFIX_ASSETS } from "@/store";

import {
  DEFAULT_ASSET_TYPES,
  ASSET_TYPES_DESCRIPTION,
  ASSET_TYPES_CUSTOM_DESCRIPTION,
  ASSET_COLORS,
  ASSET_ICONS,
} from "@/common/constants/assetManagement";
import {
  GET_ASSET_CUSTOM_FIELDS,
  GET_ASSET_TYPES,
  SAVE_ASSET_CUSTOM_FIELDS,
  SAVE_ASSET_TYPES,
  GET_ASSETS_REFRESH_MAP,
} from "@/store/actions.type";

export default {
  name: "AssetsSetup",
  data() {
    return {
      defaultList: DEFAULT_ASSET_TYPES,
      assetTypesDescription: ASSET_TYPES_DESCRIPTION,
      assetTypesCustomDescription: ASSET_TYPES_CUSTOM_DESCRIPTION,
      editedAssetId: "",
      editedCustomAssetId: "",
      editedFieldId: "",
      colors: ASSET_COLORS,
      icons: ASSET_ICONS,
      specialCharactersRule: [
        (value) =>
          /^[\w\s]+$/.test(value) ||
          "Alphabets, numeric and space are only allowed",
      ],
      maxAssetTypesLimit: 10,
      labelType: `${LABELS.asset} Types`,
      systemAssetTypes: [],
      customAssetTypes: [],
      customAssetFields: [],
      defaultIcon: "star",
      defaultColor: "#000000",
      windowSize: {
        x: 0,
        y: 0,
      },
    };
  },
  async mounted() {
    await this.getAssetTypes();
    await this.getCustomFields();
    this.initialize();
    this.handleResize();
  },
  computed: {
    ...mapGetters({
      assetTypes: MODULE_PREFIX_ASSETS + "assetTypes",
      customFields: MODULE_PREFIX_ASSETS + "assetCustomFields",
    }),
    listingHeight() {
      return this.windowSize.y - 250;
    },
  },
  methods: {
    async getAssetTypes() {
      await this.$store.dispatch(MODULE_PREFIX_ASSETS + GET_ASSET_TYPES, {});
    },
    async getCustomFields() {
      await this.$store.dispatch(
        MODULE_PREFIX_ASSETS + GET_ASSET_CUSTOM_FIELDS,
        {}
      );
    },
    initialize() {
      this.setupAssetTypes();
      this.setupCustomFields();
    },
    toggleEditSystemAsset(item) {
      this.editedAssetId = item.id;
    },
    toggleEditCustomAsset(item) {
      this.editedCustomAssetId = item.id;
    },
    toggleClose() {
      this.editedAssetId = "";
      this.editedCustomAssetId = "";
      this.editedFieldId = "";
    },
    hasMaxCustomTypesLimit() {
      //TODO: This feature is still be flushed out
      let activeCustomAssetTypes = [];
      activeCustomAssetTypes = this.assetTypes.filter((assetType) => {
        return assetType.enabled;
      });
      return activeCustomAssetTypes.length < this.maxAssetTypesLimit;
    },
    getDisplayIcon(item) {
      return require(`@/assets/images/icons/assetManagement/${item.fileName}.png`);
    },
    async saveAssetType(item) {
      if (lodashIsEmpty(item.color)) {
        item.color = this.defaultColor;
      }
      if (lodashIsEmpty(item.icon)) {
        item.icon = this.defaultIcon;
      }
      await this.$store.dispatch(MODULE_PREFIX_ASSETS + SAVE_ASSET_TYPES, item);
      this.$store.dispatch(
        MODULE_PREFIX_ASSETS + GET_ASSETS_REFRESH_MAP,
        new Date().toISOString()
      );
      this.resetEditableIds();
    },
    toggleEditCustomField(item) {
      this.editedFieldId = item.id;
    },
    setupAssetTypes() {
      //Setup System Asset Types
      this.systemAssetTypes = this.assetTypes.filter((assetType) => {
        return assetType.isSystemType;
      });
      this.defaultList.forEach((assetType) => {
        let exists = this.systemAssetTypes.some((sa) => {
          return sa.title === assetType.title;
        });

        if (!exists) {
          assetType.enabled = false;
          assetType.isDraft = true;
          this.systemAssetTypes.push(assetType);
        }
      });
      lodashSortBy(this.systemAssetTypes, ["orderBy"]); //TODO: Revisit logic

      // Setup Custom Asset Types
      this.customAssetTypes = this.assetTypes.filter((assetType) => {
        return !assetType.isSystemType;
      });
      while (this.customAssetTypes.length < 10) {
        const assetType = {
          id: uuidV4(),
          title: `Edit Custom ${LABELS.asset} Type`,
          icon: this.defaultIcon,
          color: this.defaultColor,
          enabled: false,
          isSystemType: false,
          isDraft: true,
        };
        this.customAssetTypes.push(assetType);
      }
    },
    setupCustomFields() {
      this.customAssetFields = [];
      this.customAssetFields.push(...this.customFields);
      while (this.customAssetFields.length < 10) {
        const field = {
          title: "Edit Custom Field",
          enabled: false,
          id: uuidV4(),
          isDraft: true,
        };
        this.customAssetFields.push(field);
      }
    },
    async saveCustomField(item) {
      await this.$store.dispatch(
        MODULE_PREFIX_ASSETS + SAVE_ASSET_CUSTOM_FIELDS,
        item
      );
      this.resetEditableIds();
    },
    resetEditableIds() {
      this.editedAssetId = "";
      this.editedCustomAssetId = "";
      this.editedFieldId = "";
    },
    handleResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
  watch: {
    customFields: {
      handler() {
        this.setupCustomFields();
      },
    },
    assetTypes: {
      handler() {
        this.setupAssetTypes();
      },
    },
  },
};
</script>

<style scoped>
.hyp-table-container {
  width: 1200px;
}
.details-heading {
  font-size: 18px;
  font-weight: bold;
}
.section-heading {
  font-size: 18px;
}
.content-container {
  max-width: 550px !important;
}
.color-holder {
  height: 24px;
  width: 24px;
  border-radius: 12px;
}
</style>
